import React from 'react';
import { WidgetStrategyWithStreamByRequestUid } from 'widgets/WidgetRegistry';
import { WidgetCategory } from 'widgets/WidgetCategory';
import { PortfolioSelectionRequirements } from 'widgets/PortfolioSelectionRequirements';
import { GetSymbolInfoRequestPayload } from 'widgets/symbolInfo/SymbolInfoRequest';
import { SymbolInfoCapsule } from 'widgets/symbolInfo/capsule/SymbolInfoCapsule';
import {
    initialSymbolInfoCapsuleConfigState,
    SymbolInfoCapsuleConfigState,
} from 'widgets/symbolInfo/capsule/store/config/SymbolInfoCapsuleConfigState';
import { MyPortfolioCapsuleWidgetStrategyWithConfig } from 'widgets/myPortfolioCapsules/MyPortfolioCapsuleWidgetStrategy';
import { SymbolInfoCapsuleMyPortfolioCapsuleContent } from 'widgets/symbolInfo/capsule/SymbolInfoCapsuleMyPortfolioCapsuleContent';
import { symbolInfoCapsuleDescription } from 'widgets/symbolInfo/capsule/description/SymbolInfoCapsuleDescription';
import SymbolInfoCapsuleSettings from 'widgets/symbolInfo/capsule/SymbolInfoCapsuleSettings';
import { symbolInfoStreamConfig } from 'widgets/symbolInfo/store/stream-config';
import { symbolInfoStreamedDataSelectors } from 'widgets/symbolInfo/store/streamSlice';

const useMessagesInMyPortfolioCapsules = (_sym: string) =>
    symbolInfoStreamedDataSelectors.useWidgetMessages();

export const symbolInfoCapsuleWidgetStrategy: MyPortfolioCapsuleWidgetStrategyWithConfig<SymbolInfoCapsuleConfigState> &
    WidgetStrategyWithStreamByRequestUid<GetSymbolInfoRequestPayload> = {
    title: 'Symbol Info',
    supportedHosts: ['tile'],
    reactComponentType: SymbolInfoCapsule,
    myPortfolioCapsuleContentReactComponentType:
        SymbolInfoCapsuleMyPortfolioCapsuleContent,
    categories: [WidgetCategory.TOP],
    description: symbolInfoCapsuleDescription,
    portfolioSelectionRequirements: PortfolioSelectionRequirements.SingleSymbol,
    initialConfigState: initialSymbolInfoCapsuleConfigState,
    supportsMyPortfolioCapsule: true,
    supportsMyPortfolioCapsuleConfig: true,
    renderSettingsBody,
    managedStreamConfig: symbolInfoStreamConfig,
    useMessagesInMyPortfolioCapsules,
};

function renderSettingsBody(
    config: SymbolInfoCapsuleConfigState,
    onChange: (configDelta: Partial<SymbolInfoCapsuleConfigState>) => void
) {
    return <SymbolInfoCapsuleSettings config={config} onChange={onChange} />;
}
